import { render, staticRenderFns } from "./InvestPlan.vue?vue&type=template&id=4d07aa10&scoped=true&"
import script from "./InvestPlan.vue?vue&type=script&lang=js&"
export * from "./InvestPlan.vue?vue&type=script&lang=js&"
import style0 from "./InvestPlan.vue?vue&type=style&index=0&id=4d07aa10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d07aa10",
  null
  
)

export default component.exports